<nb-card [nbSpinner]="loading" nbSpinnerStatus="primary" class="card-box">
    <nb-card-header class="content-header">
        <nb-icon class="icon" icon="{{ modalData.icon }}" status="basic"></nb-icon>
        <span class="title">{{modalData.title | translate}}</span>
        <nb-icon class="close" icon="close-outline" (click)="cancel()" *ngIf="modalData.showCancel"></nb-icon>
    </nb-card-header>

    <nb-card-body class="content-body">
        <span class="text" [innerHTML]="modalData.bodyText" translate></span>
    </nb-card-body>

    <nb-card-footer class="content-footer">
        <button nbButton [status]="modalData.buttonStatus" [size]="'large'" id="button-click" [disabled]="loading"
                (click)="confirm()" tabindex="-1">
            {{modalData.buttonName | translate}}
        </button>
        <button nbButton [size]="'large'" [status]="'control'" [appearance]="'outline'"
                (click)="cancel()" tabindex="-1" *ngIf="modalData.showCancel">
            {{'common.cancel' | translate}}
        </button>
    </nb-card-footer>
</nb-card>